import { adminHttpClient } from '../../commons/adminHttpClient'

export interface IchraCreditCardPaymentValues {
  recurlyToken: string
  frequency: number
}

const ichraMakeCreditCardPayment = (values: IchraCreditCardPaymentValues): Promise<any> => {
  return adminHttpClient.put('/AdminSignup/ichra/Subscription/Payment/CreditCard', values)
}

export default ichraMakeCreditCardPayment
